import { managementInstantDependenciesFactory } from "./dependencies.factory";

export const managamentInstantEpicDependencies = {
    instantManagementService: managementInstantDependenciesFactory.getInstantManagementService()
}
